import React from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import Fontstyling from "../../../../components/common/comman";
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import {
  GetTierDetails,
  AddTier,
  DeleteTier,
  UpdateTier,
} from "../../../../api/User/ACG/TierApi";
import CustomButton from "../../../../components/common/CustomButton";
import DeleteModal from "../../../../components/common/Modal/DeleteModal";
import CustomMaterialTable from "../../../../components/common/CustomMaterialTable";
import toastFile from "../../../../Service/ToastFile";
import { TierType } from "../../../../Utils/constants";
import CustomInputField from "../../../../components/common/CustomInputField";
import Required from "../../../../components/Required";

const schema = Yup.object().shape({
  tier_Type: Yup.string()
    .notOneOf(["Select Tier Type"], "Please select tier type")
    .required("Please select tier type"),
  tieer: Yup.string().required("Please enter tier"),
  actual_Tiering: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter actual tiering"),
  acG_Tiering: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter acg tiering"),
  factor: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter factor"),
});

const Tier = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [isGetData, setIsGetData] = useState(false);
  const [witchAction, setWitchAction] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const buttonRef = useRef(null);
  const column = [
    {
      title: "Tier Type",
      field: "tier_Type",
    },
    {
      title: "Tier",
      field: "tieer",
    },
    {
      title: "Actual Tiering",
      field: "actual_Tiering",
    },
    {
      title: "ACG Tiering",
      field: "acG_Tiering",
    },
    {
      title: "Factor",
      field: "factor",
    },
  ];

  useEffect(() => {
    if (showModal === false) {
      setSelectedRowData(null);
    }
    if (isGetData) {
      getTierDetailsData();
    }
    setIsGetData(false);
  }, [showModal]);

  useEffect(() => {
    getTierDetailsData();
  }, []);

  const getTierDetailsData = () => {
    setIsLoading(true);
    GetTierDetails()
      .then((res) => {
        if (res.status === 200 || res.status === 204) {
          setData(res.data);
        }
      })
      .catch((err) => console.log({ err }))
      .finally((res) => setIsLoading(false));
  };

  const handleActions = (values) => {
    buttonRef.current.disabled = true;

    const { tier_Type, tieer, actual_Tiering, acG_Tiering, factor } = values;
    const payload = {
      id: 0,
      tier_Type,
      tieer,
      actual_Tiering: +actual_Tiering,
      acG_Tiering: +acG_Tiering,
      factor: +factor,
    };

    if (witchAction === "add") {
      AddTier(payload).then((res) => {
        if (res.status === 200 || res.status === 204) {
          setIsGetData(true);
          toastFile("new");
          setShowModal(false);
        } else if (res?.response?.status === 400) {
          toastFile(res?.response?.data, "error");
          setShowModal(false);
        }
      });
    } else if (witchAction === "update") {
      UpdateTier(selectedRowData.id, {
        ...payload,
        id: selectedRowData.id,
      }).then((res) => {
        if (res.status === 200 || res.status === 204) {
          setIsGetData(true);
          toastFile("update");
          setShowModal(false);
        } else if (res?.response?.status === 400) {
          toastFile(res?.response?.data, "error");
          setShowModal(false);
        }
      });
    }
  };

  return (
    <div>
      <Modal
        show={showModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered={witchAction !== "delete"}
      >
        <Modal.Header closeButton onHide={() => setShowModal(false)}>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading}
          >
            {witchAction === "add"
              ? "Add "
              : witchAction === "update"
              ? "Update "
              : "Delete "}
            Tier
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {witchAction === "delete" ? (
            <DeleteModal
              onClickYes={() => {
                DeleteTier(selectedRowData?.id).then((res) => {
                  if (res.status === 200 || res.status === 204) {
                    toastFile("delete");
                    setIsGetData(true);
                    setShowModal(false);
                  }
                });
              }}
              onClickNo={() => setShowModal(false)}
            />
          ) : (
            <Formik
              validationSchema={schema}
              onSubmit={handleActions}
              initialValues={{
                tier_Type: selectedRowData?.tier_Type ?? "Select Tier Type",
                tieer: selectedRowData?.tieer,
                actual_Tiering: selectedRowData?.actual_Tiering ?? 0,
                acG_Tiering: selectedRowData?.acG_Tiering ?? 0,
                factor: selectedRowData?.factor ?? 0,
              }}
            >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                isValid,
                errors,
              }) => (
                <Form onSubmit={handleSubmit}>
                  {witchAction === "delete" ? (
                    <div className="text-wrap">
                      Are you sure that you want to delete the record?
                    </div>
                  ) : (
                    <>
                      <Row className="mb-2 gap-3">
                        <Col>
                          <CustomInputField
                            label="Tier"
                            name="tieer"
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            isRequired
                          />
                        </Col>
                        <Col>
                          <CustomInputField
                            label="Actual Tiering"
                            name="actual_Tiering"
                            maxLength={10}
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            isRequired
                          />
                        </Col>
                      </Row>
                      <Row className="mb-2 gap-3">
                        <Col>
                          <CustomInputField
                            label="ACG Tiering"
                            name="acG_Tiering"
                            maxLength={10}
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            isRequired
                          />
                        </Col>
                        <Col>
                          <CustomInputField
                            label="Factor"
                            name="factor"
                            maxLength={10}
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            isRequired
                          />
                        </Col>
                      </Row>
                      <Row className="mb-2 gap-3">
                        <Col>
                          <Form.Group>
                            <Form.Label
                              className="text-nowrap"
                              style={Fontstyling.label}
                            >
                              Tier Type
                              <Required />
                            </Form.Label>
                            <Form.Select
                              className="rounded-0"
                              style={Fontstyling.label}
                              name="tier_Type"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={
                                values.tier_Type === "Select Tier Type" &&
                                touched.tier_Type
                              }
                            >
                              {TierType.map((item) => (
                                <option
                                  value={item}
                                  selected={values.tier_Type === item}
                                >
                                  {item}
                                </option>
                              ))}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                              {errors.tier_Type}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col></Col>
                      </Row>
                    </>
                  )}
                  <div className="d-flex align-items-center justify-content-end gap-3 my-4">
                    <button
                      ref={buttonRef}
                      style={Fontstyling.savebutton}
                      type="submit"
                    >
                      save
                    </button>
                    <button
                      style={Fontstyling.cancelbutton}
                      type="reset"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </button>
                  </div>
                  <span className="text-success" style={{ fontSize: "12px" }}>
                    * No special characters are allowed
                  </span>
                </Form>
              )}
            </Formik>
          )}
        </Modal.Body>
      </Modal>
      <div className="text-end py-3 border-bottom">
        <CustomButton
          onClick={() => {
            setWitchAction("add");
            setShowModal(true);
          }}
        >
          Add Tier
        </CustomButton>
      </div>
      <CustomMaterialTable
        column={column}
        data={data}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        setWitchAction={setWitchAction}
        setSelectedRowData={setSelectedRowData}
        setShowModal={setShowModal}
        isLoading={isLoading}
      />
    </div>
  );
};

export default Tier;
